import React from "react";
import { Avatar } from "@kuda/ui";

// Map arbitrary px sizes (legacy callers) onto Kuda's Avatar size scale.
function pxToKudaSize(size) {
  if (size <= 24) return "sm";
  if (size <= 48) return "md";
  if (size <= 64) return "lg";
  if (size <= 96) return "xl";
  return "2xl";
}

function getInitials(name) {
  if (!name) return "?";
  const nameParts = name.split(" ");
  return nameParts.length > 1
    ? `${nameParts[0][0]}${nameParts[1][0]}`
    : `${nameParts[0][0]}`;
}

// Reusable Avatar Component — initials, sized against Kuda's Avatar scale.
const ColoredAvatar = ({ name, size = 40 }) => {
  return (
    <Avatar
      entity="User"
      type="Initial"
      initialLabel={getInitials(name).toUpperCase()}
      size={pxToKudaSize(size)}
    />
  );
};

export default ColoredAvatar;
